import React from 'react';
import { FormControlLabel as MuiFormControlLabel, FormControlLabelProps } from '@mui/material';
import { labelControlSx } from './FormControlLabel.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const FormControlLabel = React.forwardRef<HTMLLabelElement, FormControlLabelProps>((props, ref) => {
  return (
    <MuiFormControlLabel
      ref={ref}
      {...props}
      sx={[labelControlSx, props.sx] as SxProps<Theme>}
    />
  );
});

FormControlLabel.displayName = 'FormControlLabel';